module.exports = __webpack_public_path__ + "media/images/early-music-4-92979434c63f0d30c88f029843ac993d.jpg";